import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const FilteredItem = ({ bannerIndex, path }) => {
  return (
    <div key={bannerIndex} className={`col-6 col-md px-1 py-1 pos-banner pos-${bannerIndex}`}>
      <div className='bannerImage'>
        <Link
          className=''
          to={path}
          title={'Veja a seleção de produtos'}
        />
      </div>
    </div>
  )
}

FilteredItem.propTypes = {
  bannerIndex: PropTypes.number,
  path: PropTypes.string
}

export default FilteredItem



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/FilteredShowcase/FilteredItem.js